module.exports = __webpack_public_path__ + "images/e5b436f59e5d2d69a67a0e597692b228.svg";